﻿import $ from "jquery";

$(function () {
    $.fn.FaqAnchorList = function () {
        function init(obj) {
            //get the list we have to add items to
            var anchorListContainer = $(obj).find('.button-collection ul');
            //get the template for the items we add
            var template = Handlebars.compile($("#FaqAnchorListItemTemplate").html());
            //get all accordions and loop them
            $("div.accordion__wrapper.js--accordion-controller").each(function (index) {
                //define a model for the template
                var anchor = {}
                //get the values
                anchor.id = $(this).attr('id');
                anchor.headline = $(this).find("h3.accordion__wrapper__title").first().text();
                //append the new item.
                anchorListContainer.append(template(anchor));
            });
        }

        this.each(function () {
            init($(this));
        });
    }
    $(".FaqAnchorList").FaqAnchorList();
});





//////////////////
// WEBPACK FOOTER
// ./Scripts/Elements/FaqboxAnchorList.js
// module id = 17
// module chunks = 1